import React from 'react'
import { motion } from "framer-motion";
import Header from '../component/Header';
import Footer from '../component/Footer';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import Compliance from '../component/Compliance';

export default function ContactUs() {
    return (
        <>
            <Header />
            {/* banner section start */}
            <div className="relative h-[300px] flex items-center justify-center bg-gradient-to-br from-[#0b1f3a] to-[#0a2540] overflow-hidden">
                {/* Animated Background Glow */}
                <div className="absolute w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-3xl animate-pulse top-[-100px] left-[-100px]" />
                <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-80px] right-[-80px]" />

                {/* Glass Card */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="px-10 py-8 text-center "
                >
                    {/* Title */}
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.3 }}
                        className="text-4xl md:text-5xl font-bold text-white"
                    >
                        Contact <span className="text-orange-400">Us</span>
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5 }}
                        className="mt-4 text-gray-200 text-sm md:text-base"
                    >
                        We’re Here to Help You Navigate Financial Solutions
                        {/* <span className="text-orange-400 font-semibold">
                            Your Ambitions
                        </span> */}
                    </motion.p>
                </motion.div>
            </div>
            {/* end */}


            <section className="w-full py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">

                    {/* LEFT: FORM */}
                    <div className="lg:col-span-2 p-6 sm:p-8 ">

                        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                            Get in Touch
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Have questions about loan options, eligibility, or the application process? Our team is here to help.
                        </p>

                        <form className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                            <input
                                type="text"
                                placeholder="Full Name"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="email"
                                placeholder="Email Address"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="text"
                                placeholder="Phone Number"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <select className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400">
                                <option>Loan Application Support</option>
                                <option>Instant Loan Information</option>
                                <option>Emergency Loan Information</option>
                                <option>Personal Loan Information</option>
                                <option>Eligibility Questions</option>
                                <option>Verification Support</option>
                                <option>Existing Application Status</option>
                                <option>General Enquiry</option>
                            </select>

                            <textarea
                                placeholder="How can we help you achieve your goals?"
                                rows={4}
                                className="sm:col-span-2 border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            ></textarea>

                            

                            <div className="sm:col-span-2 flex items-start gap-3">
                            <input
                                id="agree"
                                type="checkbox"
                                required
                                className="mt-1 h-4 w-4 rounded border-gray-300 text-orange-500 focus:ring-orange-400"
                            />

                            <label htmlFor="agree" className="text-sm text-gray-600">
                                I have read and agree to the{" "}
                                <a
                                href="/terms-and-conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-orange-500 hover:text-orange-600 underline"
                                >
                                Terms & Conditions
                                </a>{" "}
                                and{" "}
                                <a
                                href="/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-orange-500 hover:text-orange-600 underline"
                                >
                                Privacy Policy
                                </a>
                                .
                            </label>
                            </div>


                            <button
                                type="submit"
                                className="sm:col-span-2 bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-medium transition"
                            >
                                Get Assistance
                            </button>

                            {/* Communication & Marketing Consent */}
                <div className="sm:col-span-2 rounded-xl border border-orange-200 bg-orange-50 p-5">
                    <h3 className="text-lg font-semibold text-gray-900 mb-3">
                        Communication & Contact
                    </h3>

                    <p className="text-sm text-gray-700 leading-7 mb-3">
                        We may use your information to communicate with you, respond to
                        inquiries, provide customer support, and share service-related
                        updates.
                    </p>

                    <p className="text-sm text-gray-700 leading-7 mb-3">
                        With your consent, we may send marketing communications via{" "}
                        <span className="font-semibold">
                            SMS, Email, RCS, WhatsApp, and Voice Calls
                        </span>.
                    </p>

                    <p className="text-sm text-gray-700 leading-7">
                        You may opt out of marketing communications at any time using the
                        unsubscribe option provided in our messages.
                    </p>
                </div>

                        </form>
                    </div>

                    {/* RIGHT: CONTACT CARDS */}
                    <div className="flex flex-col gap-6">

                        {/* Call Us */}
                        <div className="bg-white p-5 rounded-xl shadow flex gap-4 items-start">
                            <div className="bg-orange-100 p-3 rounded-lg">
                                <LocalPhoneIcon className="text-orange-500 w-5 h-5" />
                            </div>
                            <div>
                                <h3 className="font-semibold  text-lg">Call Us</h3>

                                <p className="text-gray-400 text-xs">
                                    Mon–Sat: 10:00 AM – 6:30 PM
                                </p>
                                <p className="text-gray-600 text-xl font-semibold ms-text-primary pt-1">+91 7733866663</p>
                            </div>
                        </div>

                        {/* Email */}
                        <div className="bg-white p-5 rounded-xl shadow flex gap-4 items-start">
                            <div className="bg-orange-100 p-3 rounded-lg">
                                <EmailIcon className="text-orange-500 w-5 h-5" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900">Email Us</h3>
                                <p className="text-gray-600 text-sm">
                                    For application-related questions, support queries, and general assistance.
                                </p>
                                <p className="text-gray-600 text-xl font-semibold ms-text-primary pt-1">
                                    care@b4salary.com
                                </p>
                            </div>
                        </div>

                        

                        {/* Priority Support */}
                        <div className="bg-[#072c4c] text-white p-6 rounded-xl shadow">
                            <h3 className="font-semibold mb-2">Application Support</h3>
                            <p className="text-sm text-gray-300 mb-3 leading-7">
                                Get assistance with loan applications, verification steps, and eligibility-related questions.
                            </p>
                            <button className="text-orange-400 font-medium hover:underline">
                                Access Portal →
                            </button>
                        </div>

                    </div>
                </div>

                

                

                {/* LOCATIONS */}
                <div className="max-w-7xl mx-auto mt-12">


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                        <div>
                            <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                                Our Locations
                            </h3>
                            <p>Find our registered and office addresses here. For assistance, users can also connect with us through our digital support channels.
</p>
                        </div>

                        <div className="bg-white p-5 rounded-lg shadow border-l-4 border-blue-500">
                            <p className="text-orange-500 text-xs font-semibold mb-1">
                                REGISTERED ADDRESS
                            </p>
                            <p className="text-gray-700 text-base pt-4">
                               C-31, DSIDC Rohtak Road Industrial Complex, Nangloi, Delhi  - 110041
                            </p>
                        </div>

                        <div className="bg-white p-5 rounded-xl shadow border-l-4 border-green-500">
                            <p className="text-orange-500 text-xs font-semibold mb-1">
                                OFFICE ADDRESS
                            </p>
                            <p className="text-gray-700 text-base pt-4">
                                B-7, New Multan Nagar, Paschim Vihar, New Delhi - 110056
                            </p>
                        </div>

                    </div>
                </div>
            </section>
<Compliance/>
            <Footer />
        </>
    )
}
